import PricingPageLocationJpg from "./Images/pricingPageLocation.jpg";
import PricingPageLocationWebp from "./Images/pricingPageLocation.webp";

const PricingPageLocation = {jpg: PricingPageLocationJpg, webp: PricingPageLocationWebp, alt: "Pricing", w: "440", h: "280"};

export { PricingPageLocation }